/* AROL · cada enlace conserva su destinatario y mensaje. No envía mensajes. */
(function () {
  'use strict';
  function whatsappURL(value) {
    try {
      var url = new URL(value, location.href);
      return url.protocol === 'https:' && (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') ? url : null;
    } catch (_) { return null; }
  }
  function phone(link) {
    var explicit = link.dataset.arolWaNumber;
    if (explicit && /^\d{10,15}$/.test(explicit)) return explicit;
    var url = whatsappURL(link.href);
    if (!url) return '';
    var value = url.hostname === 'wa.me' ? url.pathname.slice(1) : url.searchParams.get('phone');
    return value && /^\d{10,15}$/.test(value) ? value : '';
  }
  function decorate(root) {
    var icon = document.querySelector('.arol-wa-line__icon');
    root.querySelectorAll('a[href*="wa.me/"], a[href*="api.whatsapp.com/send"]').forEach(function (link) {
      if (!whatsappURL(link.href)) return;
      // El contenido conserva href, texto y teléfono. No se centraliza en Susana.
      if (link.hasAttribute('data-arol-wa-product') || link.hasAttribute('data-arol-wa-preserve') || link.classList.contains('arol-wa-line')) return;
      var text = link.textContent.trim() || 'Escríbenos por WhatsApp';
      link.textContent = '';link.classList.add('arol-wa-line');
      if (icon) link.appendChild(icon.cloneNode(true));
      var label = document.createElement('span');label.className = 'arol-wa-line__text';label.textContent = text;link.appendChild(label);
      link.target = '_blank';link.rel = 'noopener';link.setAttribute('aria-label', text + ' (se abre en una pestaña nueva)');
    });
  }
  function updateVariant(event) {
    var variant = event.detail && event.detail.variant;
    var section = event.target.closest && event.target.closest('[data-section-type="product"]');
    if (!variant || !section || !/^\d+$/.test(String(variant.id))) return;
    section.querySelectorAll('[data-arol-wa-product]').forEach(function (link) {
      var number = phone(link);
      if (!number) return; // Ante un enlace inválido, mantener el respaldo Liquid.
      var sku = String(variant.sku || '').trim();
      var message = (link.dataset.messagePrefix || '') + (link.dataset.productTitle || '') + (sku ? '. SKU: ' + sku : '') + ' ' + link.dataset.productUrl + '?variant=' + variant.id;
      link.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    });
  }
  function start() { decorate(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);else start();
  document.addEventListener('shopify:section:load', function (event) { decorate(event.target); });
  document.addEventListener('variant:changed', updateVariant);
})();
